import React, {useEffect, useState, useRef} from 'react'
import {CreateAssignmentOptions} from "../../helpers/CreateAssignmentOptions";
import {animateScroll} from 'react-scroll'
import Dialog from "./Dialog";
import firebase from "firebase";
import axios from "axios";
import {UserVisitedPage} from "../../helpers/UserVisitedPage";
import {CreateRecordingAssignmentOptions} from "../../helpers/CreateRecordingAssignmentOptions";

function DialogWrapper(
    {
        classLevel
    }
) {

    const property = {speakA: "", speakA_eng: "", followup: []}

    const speakerOptions = [
        {
            key: '0',
            text: 'Act as Speaker A',
            value: 0
        },
        {
            key: '1',
            text: 'Act as Speaker B',
            value: 1
        }
    ];

    const [questionSelected, setQuestionSelected] = useState(false);
    const [responseSelected, setResponseSelected] = useState(false);

    const [dialogQuestions, setDialogQuestions] = useState([]);

    const [hiddenQuestions, setHiddenQuestions] = useState([]);
    const [hiddenResponses, setHiddenResponses] = useState([]);
    const [pastDialog, setPastDialog] = useState([]);
    const [ending, setEnding] = useState(false);
    const [starting, setStarting] = useState(true);

    const [assignmentNumber, setAssignmentNumber] = useState(null);
    const [assignmentOptions, setAssignmentOptions] = useState([]);
    const [speakerNum, setSpeakerNum] = useState(1);

    const [questionNumberSelected, setQuestionNumberSelected] = useState(0);
    const [responseNumberSelected, setResponseNumberSelected] = useState(null);
    const [restart, setRestart] = useState(false);
    const [disableThis, setDisableThis] = useState(false);
    const [savedQuestion, setSavedQuestion] = useState([]);
    const [questionTurn, setQuestionTurn] = useState(true);
    const [savedResponse, setSavedResponse] = useState({
        speakB: '',
        speakB_eng: '',
        speakB_audio: ''
    });
    const [dialogResponses, setDialogResponses] = useState({speakB: []});

    const [loading, setLoading] = useState(true);
    const [dialogConvoDB, setDialogConvoDB] = useState([]);
    const [questionSounds, setQuestionSounds] = useState([]);
    const [pictures, setPictures] = useState({leftFacingHead: '', rightFacingHead: ''});
    const [progress, setProgress] = useState(0);
    const [progressText, setProgressText] = useState('');
    const [assignmentChosen, setAssignmentChosen] = useState(false);
    const isMounted = useRef(false);
    const [dialogConvoFarewells, setDialogConvoFarewells] = useState([])


    useEffect(() => {
        UserVisitedPage();
    }, [])

    useEffect(() => {
        async function fetchData() {
            let retrievedFileNames = [];

            await firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogAssignments/assignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {
                        retrievedFileNames.push(folderRef.location.path_.split('/')[4])
                    })
                }).catch(e => console.log(e));
            let tmpAssignments = [];
            for (let i = 0; i < retrievedFileNames.length; i++) {
                const assignments = firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogAssignments/assignments/' + retrievedFileNames[i]);
                await assignments.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => {
                        tmpAssignments.push(res.data);
                        setProgress(prevState => prevState + Math.round(100 / retrievedFileNames.length));
                        setProgressText('Loading assignments')
                    });

            }
            setDialogConvoDB(tmpAssignments);
            CreateRecordingAssignmentOptions(tmpAssignments, 1, 'dialogData')
                .then((res)=>{
                    setAssignmentOptions(res)

                })


        }

        fetchData()
            .then(() => {
                setLoading(false);
            })
            .catch(e => console.log(e))
    }, []);

    useEffect(() => {
        if (isMounted.current) {
            async function fetchData() {
                setProgress(0);
                setAssignmentChosen(false);
                const allSounds = firebase.storage().ref().child('sounds');
                const leftFacingPicture = firebase.storage().ref().child('pictures/LeftFacingHead.png');
                const rightFacingPicture = firebase.storage().ref().child('pictures/RightFacingHead.png');
                let leftFacingURL = await leftFacingPicture.getDownloadURL();
                let rightFacingURL = await rightFacingPicture.getDownloadURL();
                setPictures({
                    leftFacingHead: leftFacingURL,
                    rightFacingHead: rightFacingURL
                });

                let tmpGreetings;
                const greetingFile = firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogAssignments/greetings/greetings.json');
                await greetingFile.getDownloadURL()
                    .then((greetingUrl) => axios.get(greetingUrl))
                    .then(res => {
                        tmpGreetings = res.data;
                        setProgress(25);
                        setProgressText('Loading assignments')
                    });
                for (let i = 0; i < tmpGreetings.length; i++) {
                    const retrievedQuestionSoundURLS = allSounds.child(tmpGreetings[i].speakA_audio);
                    await retrievedQuestionSoundURLS.getDownloadURL().then((url) => {
                        tmpGreetings[i].speakA_audio = new Audio(url);
                    })

                    for (let w = 0; w < tmpGreetings[i].speakB_audio.length; w++) {
                        const retrievedResponseSoundURLS = allSounds.child(tmpGreetings[i].speakB_audio[w]);
                        await retrievedResponseSoundURLS.getDownloadURL().then(url => {
                            tmpGreetings[i].speakB_audio[w] = new Audio(url)

                        })
                    }
                }
                let tmpDialogResponses = [tmpGreetings];
                let tmpDialogQuestions = [];
                let tmpHiddenQuestions = [];
                setDialogResponses(tmpDialogResponses[0][0]);
                for (let i = 0; i < tmpGreetings.length; i++) {
                    tmpDialogQuestions.push(tmpGreetings[i]);
                    tmpHiddenQuestions.push(true)
                }
                setDialogQuestions([...tmpDialogQuestions]);
                setHiddenQuestions([...tmpHiddenQuestions]);

                let tmpFarewell;
                const farewellFile = firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogAssignments/farewells/farewell.json');
                await farewellFile.getDownloadURL()
                    .then((farewellUrl) => axios.get(farewellUrl))
                    .then(res => {
                        tmpFarewell = res.data;
                        setProgress(50);
                        setProgressText('Loading assignments');

                    });
                for (let i = 0; i < tmpFarewell.length; i++) {
                    const retrievedQuestionSoundURLS = allSounds.child(tmpFarewell[i].speakA_audio);
                    await retrievedQuestionSoundURLS.getDownloadURL().then((url) => {
                        tmpFarewell[i].speakA_audio = new Audio(url);
                    })

                    for (let w = 0; w < tmpFarewell[i].speakB_audio.length; w++) {
                        const retrievedResponseSoundURLS = allSounds.child(tmpFarewell[i].speakB_audio[w]);
                        await retrievedResponseSoundURLS.getDownloadURL().then(url => {
                            tmpFarewell[i].speakB_audio[w] = new Audio(url)

                        })
                    }
                }
                setDialogConvoFarewells(tmpFarewell)
                let retrievedFileNames = [];

                await firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogAssignments/assignments').listAll()
                    .then((data) => {
                        data.items.forEach((folderRef) => {
                            retrievedFileNames.push(folderRef.location.path_.split('/')[4]);
                        })
                    }).catch(e => console.log(e));
                let tmpAssignments = [];
                for (let i = 0; i < retrievedFileNames.length; i++) {
                    const assignments = firebase.storage().ref().child('assignments/Samoan10' + classLevel + '/dialogAssignments/assignments/' + retrievedFileNames[i]);
                    await assignments.getDownloadURL()
                        .then(url => axios.get(url))
                        .then(res => {
                            tmpAssignments.push(res.data);
                            setProgress(prevState => prevState + Math.round(25 / retrievedFileNames.length));
                            setProgressText('Loading assignments');
                        });
                }

                async function fetchAudio(item) {
                    for (let i = 0; i < item.length; i++) {
                        if (item[i].length == 0) {

                        } else {
                            for (let g = 0; g < item[i].followup.length; g++) {
                                fetchAudio(item[i].followup[g])
                            }

                            const retrievedQuestionSoundURLS = allSounds.child(item[i].speakA_audio);
                            await retrievedQuestionSoundURLS.getDownloadURL().then((url) => {
                                item[i].speakA_audio = new Audio(url);
                            });

                            for (let w = 0; w < item[i].speakB_audio.length; w++) {
                                const retrievedResponseSoundURLS = allSounds.child(item[i].speakB_audio[w]);
                                await retrievedResponseSoundURLS.getDownloadURL().then(url => {
                                    item[i].speakB_audio[w] = new Audio(url)

                                })
                            }
                        }
                    }
                }

                fetchAudio(tmpAssignments[assignmentNumber]).then((res) => {
                })
                setDialogConvoDB(tmpAssignments);
                setAssignmentOptions(CreateAssignmentOptions(tmpAssignments));
            }

            if (assignmentChosen) {
                fetchData().then(() => {
                    setLoading(false);
                    setAssignmentChosen(true);
                }).catch(e => console.log(e));
            }
            setEnding(false);
            setRestart(false);
            setQuestionTurn(true);
            setStarting(true);
            setQuestionNumberSelected(0);
            setResponseNumberSelected(null);
            setResponseSelected(false);
            setQuestionSelected(false);
            setPastDialog([]);
            setHiddenResponses([]);
        } else {
            isMounted.current = true;
        }


    }, [assignmentNumber, restart, speakerNum]);

    const showQuestion = (idNum) => {
        let tmpHiddenQuestions = [];
        for (let i = 0; i < hiddenQuestions.length; i++) {
            tmpHiddenQuestions.push(true)
        }
        tmpHiddenQuestions[idNum] = false;
        setHiddenQuestions([...tmpHiddenQuestions]);
        let tmpHiddenResponses = [];
        for (let i = 0; i < dialogQuestions[idNum].speakB.length; i++) {
            tmpHiddenResponses.push(true)
        }
        ;
        setHiddenResponses([...tmpHiddenResponses]);
        setDialogResponses(dialogQuestions[idNum]);
        setQuestionNumberSelected(idNum);
        setSavedQuestion(dialogQuestions[idNum]);
        scrollToBottom();
        setResponseSelected(false);
        setQuestionTurn(false);
        setQuestionSelected(true);
        if (dialogQuestions[idNum].speakB.length < 1) {
            setResponseSelected(true);
            setResponseNumberSelected(0);
            setSavedResponse({speakB: '', speakB_eng: 'No response', speakB_audio: ''})
        }
    };

    const showResponse = (idNum) => {
        let tmpHiddenResponses = [];
        for (let i = 0; i < hiddenResponses.length; i++) {
            tmpHiddenResponses.push(true);
        }
        tmpHiddenResponses[idNum] = false;
        setHiddenResponses([...tmpHiddenResponses]);
        setSavedResponse({
            speakB: savedQuestion.speakB[idNum],
            speakB_eng: savedQuestion.speakB_eng[idNum],
            speakB_audio: savedQuestion.speakB_audio[idNum]
        });
        setResponseNumberSelected(idNum);
        setResponseSelected(true);
        scrollToBottom();


    };

    const handleQuestionSelected = (idNum) => {
        let tmpHiddenQuestions = [];
        for (let i = 0; i < hiddenQuestions.length; i++) {
            tmpHiddenQuestions.push(true);
        }
        tmpHiddenQuestions[idNum] = false;
        setHiddenQuestions([...tmpHiddenQuestions]);
        let tmpHiddenResponses = [];
        for (let i = 0; i < dialogQuestions[idNum].speakB.length; i++) {
            tmpHiddenResponses.push(true);
        }
        setHiddenResponses([...tmpHiddenResponses]);
        setDialogResponses(dialogQuestions[idNum]);
        setQuestionNumberSelected(idNum);
        setResponseSelected(false);
        setQuestionSelected(true);
        setSavedQuestion(dialogQuestions[idNum]);
        setQuestionTurn(false);
        scrollToBottom();
        if (dialogQuestions[idNum].speakB.length < 1) {
            setResponseSelected(true);
            setResponseNumberSelected(0);
            setSavedResponse({speakB: '', speakB_eng: 'No response', speakB_audio: ''})
        }
        scrollToBottom()

    };

    const handleResponseSelected = (idNum) => {
        setResponseNumberSelected(idNum);
        let tmpHiddenResponses = [];
        for (let i = 0; i < hiddenResponses.length; i++) {
            tmpHiddenResponses.push(true)
        }
        tmpHiddenResponses[idNum] = false;
        setHiddenResponses([...tmpHiddenResponses]);
        setSavedResponse(savedQuestion);
        setResponseSelected(true);
        setSavedResponse({
            speakB: savedQuestion.speakB[idNum],
            speakB_eng: savedQuestion.speakB_eng[idNum],
            speakB_audio: savedQuestion.speakB_audio[idNum]
        });
        scrollToBottom()
    };
    const startDialog = (dialog) => {
        const tmp = dialog;
        setPastDialog(prevState => [...prevState, tmp]);
        setDialogResponses(dialogConvoDB[assignmentNumber][questionNumberSelected]);
        let tmpDialogQuestions = [];
        let tmpHiddenQuestions = [];
        for (let i = 0; i < dialogConvoDB[assignmentNumber].length; i++) {
            tmpDialogQuestions.push(dialogConvoDB[assignmentNumber][i]);
            tmpHiddenQuestions.push(true)
        }
        let tmpDialogResponses = [];
        tmpDialogResponses.push(dialogConvoDB[assignmentNumber][0]);
        setDialogResponses(tmpDialogResponses[0]);
        setDialogQuestions([...tmpDialogQuestions]);
        setHiddenQuestions([...tmpHiddenQuestions]);
        setStarting(false);
        setQuestionSelected(false);
        setResponseSelected(false);
        setQuestionNumberSelected(0);
        scrollToBottom();
        setQuestionTurn(true)
    };

    const saveDialog = (dialog) => {
        const tmp = dialog;
        setPastDialog(prevState => [...prevState, tmp]);
        if (dialogQuestions[questionNumberSelected].followup[responseNumberSelected].length < 1) {
            let tmpDialogQuestions = [];
            let tmpDialogResponses = [];
            let tmpHiddenQuestions = [];
            for (let i = 0; i < dialogConvoFarewells.length; i++) {
                tmpDialogQuestions.push(dialogConvoFarewells[i]);
                tmpHiddenQuestions.push(true);
            }
            setHiddenQuestions([...tmpHiddenQuestions]);
            tmpDialogResponses.push(dialogConvoFarewells);
            setDialogResponses(tmpDialogResponses[0][0]);
            setDialogQuestions([...tmpDialogQuestions]);
            setEnding(true);
        } else {
            let tmpDialogQuestions = [];
            let tmpDialogResponses = [];
            let tmpHiddenQuestions = [];
            for (let i = 0; i < dialogQuestions[questionNumberSelected].followup[responseNumberSelected].length; i++) {
                tmpDialogQuestions.push(dialogQuestions[questionNumberSelected].followup[responseNumberSelected][i]);
            }
            for (let i = 0; i < dialogQuestions[questionNumberSelected].followup.length; i++) {
                tmpHiddenQuestions.push(true);

            }

            setHiddenQuestions([...tmpHiddenQuestions]);
            tmpDialogResponses.push(dialogQuestions[questionNumberSelected].followup[responseNumberSelected][0]);
            setDialogQuestions([...tmpDialogQuestions]);
        }

        setQuestionSelected(false);
        setResponseSelected(false);
        setQuestionNumberSelected(0);
        setQuestionTurn(true);
        scrollToBottom()
    };

    const scrollToBottom = () => {
        animateScroll.scrollToBottom({
            div: "100"
        });
    };


    const handleRestart = () => {
        setRestart(true);
        setLoading(true);
    };
    const handleAssignmentChange = (event, {value}) => {
        setAssignmentNumber(value);
        setAssignmentChosen(true);
        setLoading(true);

    };
    const handleSpeakerChange = (event, {value}) => {
        setSpeakerNum(value);
        setLoading(true);

    };

    return (
        <>
            <Dialog
                dialogQuestions={dialogQuestions}
                showQuestion={showQuestion}
                hiddenQuestions={hiddenQuestions}
                questionSelected={questionSelected}
                assignmentNumber={assignmentNumber}
                dialogResponses={dialogResponses}
                saveDialog={saveDialog}
                ending={ending}
                pastDialog={pastDialog}
                handleRestart={handleRestart}
                responseSelected={responseSelected}
                handleResponseSelected={handleResponseSelected}
                speakerNum={speakerNum}
                handleQuestionSelected={handleQuestionSelected}
                speakerOptions={speakerOptions}
                assignmentOptions={assignmentOptions}
                handleAssignmentChange={handleAssignmentChange}
                handleSpeakerChange={handleSpeakerChange}
                hiddenResponses={hiddenResponses}
                showResponse={showResponse}
                disableThis={disableThis}
                setDisableThis={setDisableThis}
                starting={starting}
                startDialog={startDialog}
                savedQuestion={savedQuestion}
                responseNumberSelected={responseNumberSelected}
                savedResponse={savedResponse}
                speakerHeadImages={pictures}
                loading={loading}
                questionTurn={questionTurn}
                progress={progress}
                progressText={progressText}
                assignmentChosen={assignmentChosen}
            />
            <div id='100'/>
        </>
    )
}

export default DialogWrapper
